<template>
  <li
    class="text-gray-400 py-2 px-4 flex h-full flex-col flex-wrap justify-center items-center"
  >
    <slot></slot>
  </li>
</template>
